import { WeaponId } from './scorched-earth.types';

export interface WeaponVisual {
	projectileRadius: number;
	coreColor: string;
	glowColor: string;
	trailStart: string;
	trailEnd: string;
	trailWidth: number;
	shape: 'dot' | 'dart' | 'capsule' | 'cluster' | 'flame';
	impactMaxAge: number;
	impactStyle: 'spark' | 'fireball' | 'mushroom' | 'napalm' | 'cluster' | 'shock';
	shockwave: boolean;
	smoke: boolean;
	debrisCount: number;
	debrisHue: number;
}

export const WEAPON_VISUALS: Record<WeaponId, WeaponVisual> = {
	babyMissile: {
		projectileRadius: 2.2,
		coreColor: '#f8fafc',
		glowColor: '#dbeafe',
		trailStart: 'rgba(255,255,255,0)',
		trailEnd: 'rgba(191,219,254,0.55)',
		trailWidth: 1.5,
		shape: 'dot',
		impactMaxAge: 20,
		impactStyle: 'spark',
		shockwave: false,
		smoke: false,
		debrisCount: 6,
		debrisHue: 42,
	},
	missile: {
		projectileRadius: 3.2,
		coreColor: '#93c5fd',
		glowColor: '#bfdbfe',
		trailStart: 'rgba(255,255,255,0)',
		trailEnd: 'rgba(147,197,253,0.72)',
		trailWidth: 2.2,
		shape: 'dart',
		impactMaxAge: 24,
		impactStyle: 'fireball',
		shockwave: true,
		smoke: true,
		debrisCount: 8,
		debrisHue: 36,
	},
	babyNuke: {
		projectileRadius: 4,
		coreColor: '#fde047',
		glowColor: '#fbbf24',
		trailStart: 'rgba(255,255,255,0)',
		trailEnd: 'rgba(251,191,36,0.75)',
		trailWidth: 2.8,
		shape: 'capsule',
		impactMaxAge: 30,
		impactStyle: 'mushroom',
		shockwave: true,
		smoke: true,
		debrisCount: 12,
		debrisHue: 28,
	},
	nuke: {
		projectileRadius: 5.5,
		coreColor: '#fef08a',
		glowColor: '#f97316',
		trailStart: 'rgba(255,255,255,0)',
		trailEnd: 'rgba(249,115,22,0.82)',
		trailWidth: 3.5,
		shape: 'capsule',
		impactMaxAge: 36,
		impactStyle: 'mushroom',
		shockwave: true,
		smoke: true,
		debrisCount: 18,
		debrisHue: 20,
	},
	mirv: {
		projectileRadius: 3.8,
		coreColor: '#67e8f9',
		glowColor: '#22d3ee',
		trailStart: 'rgba(255,255,255,0)',
		trailEnd: 'rgba(34,211,238,0.68)',
		trailWidth: 2,
		shape: 'cluster',
		impactMaxAge: 22,
		impactStyle: 'cluster',
		shockwave: true,
		smoke: false,
		debrisCount: 10,
		debrisHue: 190,
	},
	napalm: {
		projectileRadius: 3,
		coreColor: '#fb923c',
		glowColor: '#ea580c',
		trailStart: 'rgba(255,255,255,0)',
		trailEnd: 'rgba(234,88,12,0.78)',
		trailWidth: 2.6,
		shape: 'flame',
		impactMaxAge: 28,
		impactStyle: 'napalm',
		shockwave: false,
		smoke: true,
		debrisCount: 8,
		debrisHue: 22,
	},
};
